import { InjectionToken } from "@angular/core";

export const IS_TEST = new InjectionToken<boolean>("isTest");
